import React from 'react'
import { Spin } from 'antd'

class DelayHideLoading extends React.Component {
  state = {
    show: true,
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        show: false,
      })
    }, 1000)
  }
  render() {
    const { show } = this.state
    return show ? (
      <Spin />
    ) : (
      <span style={{ width: '100%', display: 'block', textAlign: 'left' }}>
        视频待录制
      </span>
    )
  }
}

export default DelayHideLoading
